import { render, staticRenderFns } from "./RequestNewCardForm.vue?vue&type=template&id=06e1799d"
import script from "./RequestNewCardForm.vue?vue&type=script&lang=ts"
export * from "./RequestNewCardForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports